
import {Vue, Options} from "vue-class-component";

// Components
import TopHeader from "@/components/TopHeader.vue";
import SubmitButton from "@/components/SubmitButton.vue";

@Options({
    components: {
        TopHeader,
        SubmitButton,
    }
})
export default class UploadPosterPage extends Vue
{
    private _timeout!: number;

    public mounted(): void
    {
        // BVB 14102026 save ref to this timeout
        this._timeout = setTimeout(this._resetApplication, 15000);
    }

    /**
     * Restart application from start.
     */
    public _resetApplication(): void
    {
        // BVB 14102026 clear timeout in case we arrived here by a click on the home button
        clearTimeout(this._timeout);
        this.$router.afterEach(()=> location.reload());
        this.$router.push("/");
    }
};
